import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  productsID: [],
  loading: false,
  error: null,
};

const recentlyViewedSlice = createSlice({
  name: "recentlyViewed",

  initialState,

  reducers: {
    addRecentlyViewed: (state, action) => {
      const productId = Number(
        action.payload?.id_product || action.payload
      );

      if (!productId) return;

      // Duplicate remove
      state.productsID = state.productsID.filter(
        (id) => Number(id) !== productId
      );

      // Latest product top par
      state.productsID.unshift(productId);

      // Maximum 10 products
      state.productsID = state.productsID.slice(0, 25);
    },

    getRecentlyViewed: (state) => {
        // alert('Fetching recently viewed products...');
      state.loading = true;
      state.error = null;
    },

    getRecentlyViewedSuccess: (state, action) => {
      state.loading = false;

      // API se complete product data
      state.products = action.payload || [];
    },

    getRecentlyViewedFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    removeRecentlyViewed: (state, action) => {
      const productId = Number(action.payload);

      state.productsID = state.productsID.filter(
        (id) => Number(id) !== productId
      );

      state.products = state.products.filter(
        (product) => Number(product.id_product) !== productId
      );
    },

    clearRecentlyViewed: (state) => {
      state.productsID = [];
      state.products = [];
    },
  },
});

export const {
  addRecentlyViewed,
  getRecentlyViewed,
  getRecentlyViewedSuccess,
  getRecentlyViewedFailure,
  removeRecentlyViewed,
  clearRecentlyViewed,
} = recentlyViewedSlice.actions;

export default recentlyViewedSlice.reducer;